import React from 'react'
import { useParams } from 'react-router-dom'
import { useLoggedInUser } from '../../../app/hooks/useLoggedInUser'
import { useGetShipmentByIdQuery } from '../../../app/redux-fetch/apiOrders'
import SpinnerBoxBlock from '../../../components/Spinner/SpinnerBoxBlock'
import ViewShipment from './ViewShipment'

const ViewShipmentContainer: React.FC = () => {
  const { id } = useParams<{ id?: string }>()
  const { tenantId } = useLoggedInUser()

  const { data: order, isSuccess: shipmentLoaded } = useGetShipmentByIdQuery(
    {
      tenantId: tenantId,
      shipmentId: Number(id),
    },
    { skip: !id, refetchOnMountOrArgChange: true }
  )

  if (!shipmentLoaded) {
    return <SpinnerBoxBlock />
  }

  return <ViewShipment order={order} />
}

export default ViewShipmentContainer
